import { User } from 'linebuster-types';
import { createContext } from 'react';

interface AlertContextValue {
  setError: (message: string) => void,
  setSuccess: (message: string) => void,
}

export const AlertContext = createContext<AlertContextValue>({
  setError: () => {},
  setSuccess: () => {},
});

interface UserContextValue {
  user: User | null | undefined,
  setUser: (user: User | null) => void,
  hasPermission: (route: string) => boolean | undefined,
}

export const UserContext = createContext<UserContextValue>({
  user: undefined,
  setUser: () => {},
  hasPermission: () => false,
});
